var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAddWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_862_70299)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_862_70299",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.046875 0.339844H20.0469V20.3398H0.046875V0.339844Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_862_70299)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_862_70299",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.046875 0.339844H20.0469V20.3398H0.046875V0.339844Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_862_70299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0478 1.17578C8.23478 1.17578 6.4625 1.7134 4.95505 2.72064C3.4476 3.72789 2.27268 5.15953 1.57888 6.83452C0.885075 8.50951 0.703545 10.3526 1.05724 12.1308C1.41094 13.9089 2.28398 15.5423 3.56596 16.8243C4.84794 18.1062 6.48129 18.9793 8.25945 19.333C10.0376 19.6867 11.8807 19.5051 13.5557 18.8113C15.2307 18.1175 16.6623 16.9426 17.6696 15.4352C18.6768 13.9277 19.2144 12.1554 19.2144 10.3424C19.2144 7.9113 18.2487 5.57972 16.5296 3.86064C14.8105 2.14155 12.4789 1.17578 10.0478 1.17578ZM15.3703 11.3733C15.3698 11.4907 15.323 11.6032 15.2399 11.6863C15.1569 11.7693 15.0444 11.8162 14.9269 11.8166H11.5261V15.2174C11.5257 15.3349 11.4788 15.4474 11.3958 15.5304C11.3127 15.6135 11.2002 15.6603 11.0828 15.6608H9.01277C8.89533 15.6603 8.78282 15.6135 8.69978 15.5304C8.61673 15.4474 8.56988 15.3349 8.56944 15.2174V11.8208H5.16861C5.05116 11.8203 4.93865 11.7735 4.85561 11.6904C4.77256 11.6074 4.72571 11.4949 4.72527 11.3774V9.30745C4.72571 9.19 4.77256 9.07749 4.85561 8.99445C4.93865 8.9114 5.05116 8.86455 5.16861 8.86411H8.56861V5.46328C8.56905 5.34584 8.6159 5.23333 8.69894 5.15028C8.78199 5.06724 8.8945 5.02039 9.01194 5.01995H11.0786C11.1961 5.02039 11.3086 5.06724 11.3916 5.15028C11.4747 5.23333 11.5215 5.34584 11.5219 5.46328V8.86328H14.9228C15.0402 8.86372 15.1527 8.91057 15.2358 8.99362C15.3188 9.07666 15.3657 9.18917 15.3661 9.30661L15.3703 11.3733Z",
    fill: "#9196AF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_862_70299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.046875 0.339844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddWallet);
export default __webpack_public_path__ + "static/media/icon-add-wallet.b21e7eb9b447daf74261970b5549ad2c.svg";
export { ForwardRef as ReactComponent };